var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-rating"},[_c('span',{staticClass:"rating"},[_vm._v(_vm._s(_vm.rating)+"/5")]),_vm._v(" "),_c('RatingStars',{attrs:{"rating":_vm.rating}}),_vm._v(" "),(_vm.reviews.ratings)?_c('span',{staticClass:"ratings"},[_vm._v("("+_vm._s(_vm.reviews.ratings)+")")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }